// SPDX-License-Identifier: MIT
/** 2D camera moves applied to the canvas transform: push-ins, drifts, handheld, impacts. */
import { noise1 } from '../core/noise.ts';
import { DESIGN_H, DESIGN_W } from '../scene.ts';
type Ctx = CanvasRenderingContext2D;
/** Scale around a point (default: frame centre). */
export function zoom(ctx: Ctx, scale: number, cx = DESIGN_W / 2, cy = DESIGN_H / 2): void {
    ctx.translate(cx, cy);
    ctx.scale(scale, scale);
    ctx.translate(-cx, -cy);
}
/** Rotate around a point (radians). */
export function roll(ctx: Ctx, angle: number, cx = DESIGN_W / 2, cy = DESIGN_H / 2): void {
    ctx.translate(cx, cy);
    ctx.rotate(angle);
    ctx.translate(-cx, -cy);
}
/** Organic handheld drift: `amount` px of wander at `speed` Hz-ish. Deterministic in t. */
export function handheld(ctx: Ctx, t: number, amount = 6, speed = 0.7, seed = 3): void {
    ctx.translate(noise1(t * speed, seed) * amount, noise1(t * speed, seed + 17) * amount * 0.7);
    roll(ctx, noise1(t * speed * 0.6, seed + 31) * amount * 0.0006);
}
/** Impact shake that decays from `strength` px; feed it a beat envelope (kit.beat.hits/pulse). */
export function shake(ctx: Ctx, t: number, strength: number, seed = 9): void {
    if (strength <= 0.01)
        return;
    ctx.translate(noise1(t * 40, seed) * strength, noise1(t * 40, seed + 5) * strength);
}
